import React, { Component } from 'react';
import DrawableCanvas from 'react-drawable-canvas';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeMap } from '../../actions/ts_map_actions.js';
import { updateModal } from '../../actions/modal.js';
import { clearDraw } from '../../actions/ts_overlay_actions.js';
import { updateCanvas } from '../../actions/ts_canvas_actions.js';
import { setActive } from '../../actions/ts_active_actions.js';
import { Button, Grid, Row, Col, Thumbnail } from 'react-bootstrap';

import Gears4 from './games/gears4.jsx';
import Gears5 from './games/gears5.jsx';
import CS_GO from './games/csgo.jsx';
import Lawbreakers from './games/lawbreakers.jsx';
import Rainbowsix from './games/rainbowsix.jsx';
import RogueCompany from './games/roguecompany.jsx';
import Sports from './games/sports.jsx';
import Valorant from './games/valorant.jsx';
import About from '../about/';
import Login_Register from '../login_register/';
import Version_History from '../version_history/';
import logger from '../../actions/log.js';
import Patron from '../../images/trickstrat/patron.png';
import Promo from '../promo/'
import {
  GEARS4,
  CSGO,
  LAWBREAKERS,
  RS6,
  ROGUECOMPANY,
  TRICKSTRAT,
  WELCOME,
  SPORTS,
  GEARS5,
  VALORANT
} from '../../utils/maps/types';
import utils from '../../utils/config.js';
import Gears4Logo from '../../images/gears4/logo.jpg';
import Gears5Logo from '../../images/gears5/logo.jpg';
import RogueCompanyLogo from '../../images/roguecompany/logo.jpg';
import ValorantLogo from '../../images/valorant/logo.jpg';
import CodLogo from '../../images/codmw/logosoon.jpg';
import SketchLogo from '../../images/trickstrat/sketchLogo.png';
import SportsLogo from '../../images/trickstrat/sportsLogo.png';

class Menu extends Component {

  constructor(props) {
      super(props);
  }

changeMap(game,map)
{
  var {overlay} = this.props;
  this.props.changeMap(game,map);
  logger.logMapClick(game,map);
  this.props.clearDraw(overlay.color,overlay.color1,overlay.color2);
  this.props.updateModal(false,null);
  this.props.updateCanvas(null,null,[]);
  this.props.setActive(null,null);
}
gameSelect(game,content)
{
  this.props.updateModal(true,content);
}
    render() {
        var {currentUser} = this.props;
          var version = utils.getVersion();
          var isDisabled = true;
          var style = "mapDisabledStyle";
          var tsStyle = "loginStyle";
          var text = "Login to select a map";
          var link =   <button className="mapStyle" onClick={(event) => {this.props.updateModal(true,<Login_Register/>);}}>{text}</button>;
          var imgPatron = <span className="titleText"></span>
          var games = null;
          if (currentUser && currentUser.uid) {
           isDisabled = false;
           style = "mapStyle";
           tsStyle = "mapStyle";
           text = "Sketch Pad";
           link =  <button className="mapStyle" onClick={(event) => {this.changeMap(TRICKSTRAT,"SKETCH");}}>{text}</button>;
           games = <div><Row id="divThumbnailBox">
              <Col xs={4} md={4}>
             <Thumbnail bsClass="thumbnail thumbnailGame" src={RogueCompanyLogo} alt="thumbnail" onClick={(event) => {this.gameSelect(ROGUECOMPANY,<RogueCompany/>);}}>
               <br/>
             </Thumbnail>
             </Col>
           <Col xs={4} md={4}>
             <Thumbnail bsClass="thumbnail thumbnailGame" src={ValorantLogo} alt="thumbnail" onClick={(event) => {this.gameSelect(VALORANT,<Valorant/>);}}>
               <br/>
             </Thumbnail>
             </Col>
           <Col xs={4} md={4}>
             <Thumbnail bsClass="thumbnail thumbnailGame" src={Gears5Logo} alt="thumbnail" onClick={(event) => {this.gameSelect(Gears5,<Gears5/>);}}>
             <br/>
             </Thumbnail>
             </Col>
             </Row>
             <Row id="divThumbnailBox">
           <Col xs={4} md={4}><Thumbnail bsClass="thumbnail thumbnailGame" src={Gears4Logo} alt="thumbnail" onClick={(event) => {this.gameSelect(GEARS4,<Gears4/>);}}> <br/></Thumbnail></Col>
           <Col xs={4} md={4}><Thumbnail bsClass="thumbnail thumbnailGame" src={SketchLogo} alt="thumbnail" onClick={(event) => {this.changeMap(TRICKSTRAT,"SKETCH");}}> <br/></Thumbnail></Col>
           <Col xs={4} md={4}><Thumbnail bsClass="thumbnail thumbnailGame" src={SportsLogo} alt="thumbnail" onClick={(event) => {this.gameSelect(SPORTS,<Sports/>);}}> <br/></Thumbnail></Col>        
           </Row>
            </div>
          }
        return (
          <div>
            <Promo/>
            <span className="menuHeaderText">Select a Game</span><br/>
            {games}
          </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeMap, clearDraw, updateModal, updateCanvas, setActive
    }, dispatch);
}

function mapStateToProps(state) {
    return { map: state.map, overlay: state.overlay, currentUser:state.currentUser, canvas : state.canvas };
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/app/components/menu/index.jsx